/*
    Archivo: assets/p-variant-picker-pdp.js
    Se llama en theme.liquid --> p-head-styles-and-scripts.liquid
*/
import { CartAddEvent } from '@theme/events';

class PDPvariantPicker {
    constructor(element) {
        this.element = element;
        const productDataElement = this.element.querySelector('script[type="application/json"][p-product-data]');
        if (!productDataElement) {
            console.error('Product data not found!');
            return;
        }
        this.product = JSON.parse(productDataElement.textContent); 
        this.variants = this.product.variants;   
        this.variantIdInput = this.element.querySelector('input[name="id"]');
        this.atcButton = this.element.querySelector('button[type="submit"]');
        this.atcTextAvailable = this.atcButton.dataset.pangoTextAvailable;
        this.atcTextUnavailable = this.atcButton.dataset.pangoTextUnavailable;
        this.init();
    }

    init() {
        this.attachOption1Listeners();
        this.attachOption2Listeners();
        this.form = this.element;
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    onOptionChanged() {
        setTimeout(() => {
            const selectedVariant = this.getSelectedVariant();    
            if (selectedVariant) {
                this.doEveryVariantChange(selectedVariant)
                if (selectedVariant.available) {
                    this.enableAtc();
                } else {
                    this.disableAtc()
                }
            } else {
                this.disableAtc();
            }
        }, 100);
    }
    enableAtc() {
        this.atcButton.disabled = false;
        this.atcButton.classList.remove('is-disabled');
        this.atcButton.textContent = this.atcTextAvailable;
    }
    disableAtc() {
        this.atcButton.disabled = true;
        this.atcButton.classList.add('is-disabled');
        this.atcButton.textContent = this.atcTextUnavailable;
    }
    getSelectedVariant(){
        const inputs = this.element.querySelectorAll('input[type="radio"]:checked');
        const selectedValues = [];
        inputs.forEach(input => {
            const position = parseInt(input.dataset.pangoOptionPosition, 10);
            const value = input.dataset.pangoOptionValue;
            selectedValues[position - 1] = value;
        });

        const selectedVariant = this.variants.find(variant =>
            variant.options.every((opt, i) => selectedValues[i] === undefined || opt === selectedValues[i])
        );
        return selectedVariant;
    }

    doEveryVariantChange(selectedVariant){
        //console.log("dentro doEveryVariantChange - Selected variant ID", selectedVariant.id);
        this.variantIdInput.value = selectedVariant.id;  // actualizamos Variant Id del form input
        this.updateUrlWithVariant(selectedVariant);
        this.updatePrice(selectedVariant);
        this.updateOption1Legend();
        this.updateOption2Legend();
        // este evento ahora lo utilizamos solo para el sync con sticky atc, pero se deberia utilizar para todo
        document.dispatchEvent(new CustomEvent('pango:variant:change', {
            bubbles: true,
            detail: { variant: selectedVariant }
        }));
    }
    attachOption1Listeners() {
        const inputs = this.element.querySelectorAll('[data-pango-option-position="1"]');
        inputs.forEach(input => {
            input.addEventListener('click', () => {
                // console.log("click on option 1")
                this.onOptionChanged();
                this.updateOption2Values();
            });
        });
    } 
    attachOption2Listeners() {
        const inputs =  this.element.querySelectorAll('[data-pango-option-position="2"]');
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                // console.log("click on option 2")
                this.onOptionChanged();
            });
        });
    } 

    updateOption2Values() {
        const colorInput = this.element.querySelector('input[data-pango-option-position="1"]:checked');
        if (!colorInput) return;
        const selectedColor = colorInput.dataset.pangoOptionValue;
        const selectedColorImageUrl = colorInput.dataset.pangoOption1Img;
        const selectedColorHoverImageUrl = colorInput.dataset.pangoOption1ImgHover;
        
        const esconderColores = this.element.hasAttribute('esconder-colores-sin-tallas'); // metacampo ultima llamada
        
        const validVariants = this.variants.filter(v => v.options[0] === selectedColor && v.available);
        const availableSizes = [...new Set(validVariants.map(v => v.options[1]))];

        const option2Container = this.element.querySelector('[data-pango-option-wrapper="2"]');
        if (!option2Container) return;

        const previousOption2Value = option2Container.querySelector('input:checked')?.value; // talla que estaba selecionada

        option2Container.innerHTML = '';
        const allSizes = [...new Set(this.variants.filter(v => v.options[0] === selectedColor).map(v => v.options[1]))];
        allSizes.forEach(size => {
            const isAvailable = availableSizes.includes(size);            
            if (esconderColores && !isAvailable) return; // ← si el atributo está presente, skip

            const label = document.createElement('label');
            label.innerHTML = `
                <input
                type="radio"
                name="option2"
                data-pango-option-position="2"
                data-pango-option-value="${size}"
                value="${size}"
                aria-label="${size}"
                ${isAvailable ? '' : 'aria-disabled="true"'}
                class="hidden"
                >
                <span class="p-talla">${size}</span>
            `;
            if (!isAvailable) label.classList.add('is-disabled');
            option2Container.appendChild(label);
        });

        this.updateSelectedOptions(option2Container,previousOption2Value);
        this.attachOption2Listeners();
    }

    updateSelectedOptions(option2Container,previousOption2Value){
        // mantener la talla previa si sigue disponible
        // Si no está disponible, seleccionar la primera disponible
        // si no hay ninguna variante disponible de ninguna opcion, queda seleccionada la primera.
        const previousInput = option2Container.querySelector(`input[value="${previousOption2Value}"]`);

        if (previousInput) {
            previousInput.checked = true;
        } else {
            const firstAvailable = option2Container.querySelector('input:not([aria-disabled])');
            if (firstAvailable) firstAvailable.checked = true;
        }
    }
    updateUrlWithVariant(selectedVariant){
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariant.id);
        history.replaceState({}, '', url);
    }
    // actualiza precio 
    updatePrice(selectedVariant) {          
        const priceContainer = document.querySelector('.p-pdp-info [p-info-price]');
        if (!priceContainer) return;

        const price = selectedVariant.price;
        const compareAtPrice = selectedVariant.compare_at_price;
        const hasDiscount = compareAtPrice && compareAtPrice > price;

        const formatMoney = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')}€`;

        const priceRegularEl = priceContainer.querySelector('[pdp-price-regular]');
        const priceSaleEl = priceContainer.querySelector('[pdp-price-sale]');
        const priceItemSaleEl = priceContainer.querySelector('[pdp-price-sale-current]');
        const compareAtPriceEl = priceContainer.querySelector('[pdp-price-compare]');
        const regularPriceEl = priceContainer.querySelector('[pdp-price]');

        priceRegularEl.toggleAttribute('hidden', hasDiscount);
        priceSaleEl.toggleAttribute('hidden', !hasDiscount);

        if (hasDiscount) {
            if (priceItemSaleEl) priceItemSaleEl.textContent = formatMoney(price);
            if (compareAtPriceEl) compareAtPriceEl.textContent = formatMoney(compareAtPrice);
        } else {
            if (regularPriceEl) regularPriceEl.textContent = formatMoney(price);
        }
    }

    // Actualiza selected option value name 
    updateOption1Legend() {
        const checkedInput = this.element.querySelector('input[data-pango-option-position="1"]:checked' );
        if (!checkedInput) return;
        const translated = checkedInput.dataset.pangoOptionValueTranslated;
        if (!translated) return;
        const label = this.element.querySelector('[p-pdp-options-1-legend]');
        if (!label) return;
        label.textContent = translated;
    }
    updateOption2Legend() {
        const checkedInput = this.element.querySelector('input[data-pango-option-position="2"]:checked' );
        if (!checkedInput) return;
        const translated = checkedInput.dataset.pangoOptionValue;
        if (!translated) return;
        const label = this.element.querySelector('[p-pdp-options-2-legend]');
        if (!label) return;
        label.textContent = translated;
    }

    // Add to cart - open drawer - update drawer - update bubble
    handleSubmit(event) {
        event.preventDefault();

        const id = this.variantIdInput.value;
        if (!id) return;

        const quantityInput = this.element.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id, quantity })
        })
        .then(response => {
            if (!response.ok) throw new Error('Error adding to cart');
            return response.json();
        })
        .then(data => {
            document.dispatchEvent(new CartAddEvent({
                resource: data
            }));
        })
        .catch(error => console.error('Error:', error));
    }
}

// ————————————————————————————————————————————————————————————————————————————————
// START - inicializa todos los vriant picker
// ———————————————————————————————————————————————————————————————————————————————— 
function initPDPvariantPicker() {
  const form = document.querySelector('.p-variant-picker-pdp:not([data-pango-initialized])');
  if (!form) return;
  form.setAttribute('data-pango-initialized', 'true');
  new PDPvariantPicker(form); // 👈 ahora sí apunta a la clase
}

const observer = new MutationObserver(() => {
  if (document.querySelector('.p-variant-picker-pdp:not([data-pango-initialized])')) {
    initPDPvariantPicker();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// ------------------------------
// inicializa on Dom loaded
// ------------------------------
document.addEventListener('DOMContentLoaded', initPDPvariantPicker);
